import { Socket } from 'ngx-socket-io';
import { Inject, Injectable } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { IS_SERVER_PLATFORM } from '../constant';
import { Observable, Subscriber } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserSocket extends Socket {
  public onConnect$() {
    if (!this.isServer) {
      return new Observable((subscriber: Subscriber<any>) => {
        // this.on('connect', (info: any) => {
        //   subscriber.next(null);
        //   this.setAndUpdateSocketId(this.ioSocket.id);
        // });
        this.on('connect', () => {
          subscriber.next(null);
          this.setAndUpdateSocketId(this.ioSocket.id ?? '');
        });
      });
    } else {
      return new Observable<any>();
    }
  }

  public onDisconnect$() {
    if (!this.isServer) {
      return new Observable((subscriber: Subscriber<any>) => {
        this.on('disconnect', () => {
          subscriber.next(null);
        });
      });
    } else {
      return new Observable<any>();
    }
  }

  constructor(
    configService: ConfigService,
    @Inject(IS_SERVER_PLATFORM) private isServer: boolean
  ) {
    super({ options: {}, url: configService.getBaseUrl() });

    if (isServer) {
      setTimeout(() => {
        this.disconnect();
      }, 1);
    }
  }

  public setAndUpdateSocketId(value: string) {
    if (!this.isServer) {
      localStorage.setItem('socketId', value);
    }
  }
}
